import React from 'react';

import NoDataWidget from '../NoDataWidget';

function NoAnswersYet({id, question, options, unPin}) {
  return <NoDataWidget id={id} title={question.text} options={options} question={question} unPin={unPin}/>;
}

export default NoAnswersYet;
